var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "scroll-to-link-wrapper" }, [
    _c(
      "a",
      {
        staticClass: "scroll-to-link",
        class: this.classes,
        attrs: { href: _vm.target },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.didSelectLink()
          },
        },
      },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/ScrollToLink.vue